var version = '';
defer(function () {
    deferUsercentrics(function() {
        // is Google Maps accepted? - if not, generate Overlay
        var consentIdGoogleMaps = 'S1pcEj_jZX';
        var overlayClassGoogleMaps = 'uoConsentMap';
        var overlayGoogleMaps = '<div class="uoConsentDummyMapOverlay"><p>Um diesen Inhalt benutzen zu können, müssen Sie erst der Datenschutzerklärung zustimmen!</p><p><a class="btn btn-sm btn-primary uoConsentAcceptAll">Alles akzeptieren</a></p><p><a class="btn btn-sm btn-primary uoConsentAcceptMaps">Google Maps akzeptieren</a></p><p><a class="btn btn-sm btn-secondary uoConsentOptions">Einstellungen</a></p></div>';
        var buttonClassGoogleMaps = 'uoConsentAcceptMaps';
        var overlayGoogleMapsClass = 'uoConsentDummyMapOverlay';
        
        // is Youtube accepted? - if not, generate Overlay
        var consentIdYoutube = 'BJz7qNsdj-7';
        var overlayClassYoutube = 'uoConsentYt';
        var overlayYoutube = '<div class="uoConsentDummyYtOverlay"><p>Um diesen Inhalt benutzen zu können, müssen Sie erst der Datenschutzerklärung zustimmen!</p><p><a class="btn btn-sm btn-primary uoConsentAcceptAll">Alles akzeptieren</a></p><p><a class="btn btn-sm btn-primary uoConsentAcceptYt">YouTube akzeptieren</a></p><p><a class="btn btn-sm btn-secondary uoConsentOptions">Einstellungen</a></p></div>';
        var buttonClassYt = 'uoConsentAcceptYt';
        var overlayYoutubeClass = 'uoConsentDummyYtOverlay';
        
        // is Vimeo accepted? - if not, generate Overlay
        var consentIdVimeo = 'HyEX5Nidi-m';
        var overlayClassVimeo = 'uoConsentVimeo';
        var overlayVimeo = '<div class="uoConsentDummyVimeoOverlay"><p>Um diesen Inhalt benutzen zu können, müssen Sie erst der Datenschutzerklärung zustimmen!</p><p><a class="btn btn-sm btn-primary uoConsentAcceptAll">Alles akzeptieren</a></p><p><a class="btn btn-sm btn-primary uoConsentAcceptVimeo">Vimeo akzeptieren</a></p><p><a class="btn btn-sm btn-secondary uoConsentOptions">Einstellungen</a></p></div>';
        var buttonClassVimeo = 'uoConsentAcceptVimeo';
        var overlayVimeoClass = 'uoConsentDummyVimeoOverlay';

        // is 3Q Video accepted? - if not, generate Overlay
        var consentId3Q = 'kXg9DeFEK';
        var overlayClass3Q = 'uoConsent3Q';
        var overlay3Q = '<div class="uoConsentDummy3QOverlay"><p>Um diesen Inhalt benutzen zu können, müssen Sie erst der Datenschutzerklärung zustimmen!</p><p><a class="btn btn-sm btn-primary uoConsentAcceptAll">Alles akzeptieren</a></p><p><a class="btn btn-sm btn-primary uoConsentAccept3Q">3Q Video akzeptieren</a></p><p><a class="btn btn-sm btn-secondary uoConsentOptions">Einstellungen</a></p></div>';
        var buttonClass3Q = 'uoConsentAccept3Q';
        var overlay3QClass = 'uoConsentDummy3QOverlay';
        
        // is Facebook accepted? - if not, generate Overlay
        var consentIdFacebook = 'XYQZBUojc';
        var overlayClassFacebook = 'uoConsentFacebook';
        var overlayFacebook = '<div class="uoConsentDummyFacebookOverlay"><p>Um diesen Inhalt benutzen zu können, müssen Sie erst der Datenschutzerklärung zustimmen!</p><p><a class="btn btn-sm btn-primary uoConsentAcceptAll">Alles akzeptieren</a></p><p><a class="btn btn-sm btn-primary uoConsentAcceptFacebook">Facebook akzeptieren</a></p><p><a class="btn btn-sm btn-secondary uoConsentOptions">Einstellungen</a></p></div>';
        var buttonClassFacebook = 'uoConsentAcceptFacebook';
        var overlayFacebookClass = 'uoConsentDummyFacebookOverlay';

        window.consentArr = {};
        consentArr[consentIdGoogleMaps] = {'overlayClass': overlayClassGoogleMaps, 'overlay': overlayGoogleMaps, 'buttonClass': buttonClassGoogleMaps, 'bannerClass': overlayGoogleMapsClass};
        consentArr[consentIdYoutube] = {'overlayClass': overlayClassYoutube, 'overlay': overlayYoutube, 'buttonClass': buttonClassYt, 'bannerClass': overlayYoutubeClass};
        consentArr[consentIdVimeo] = {'overlayClass': overlayClassVimeo, 'overlay': overlayVimeo, 'buttonClass': buttonClassVimeo, 'bannerClass': overlayVimeoClass};
        consentArr[consentId3Q] = {'overlayClass': overlayClass3Q, 'overlay': overlay3Q, 'buttonClass': buttonClass3Q, 'bannerClass': overlay3QClass};
        consentArr[consentIdFacebook] = {'overlayClass': overlayClassFacebook, 'overlay': overlayFacebook, 'buttonClass': buttonClassFacebook, 'bannerClass': overlayFacebookClass};

        // Usercentrics CMP V1
        if(version === 'V1') {
            checkConsentFor(consentIdGoogleMaps, overlayClassGoogleMaps, overlayGoogleMaps);
            checkConsentFor(consentIdYoutube, overlayClassYoutube, overlayYoutube);
            checkConsentFor(consentIdVimeo, overlayClassVimeo, overlayVimeo);
            checkConsentFor(consentId3Q, overlayClass3Q, overlay3Q);
            checkConsentFor(consentIdFacebook, overlayClassFacebook, overlayFacebook);
            // Accept all 
            $('.uoConsentAcceptAll').each(function(){
                $(this).on("click", function(e){
                    e.preventDefault();
                    usercentrics.acceptAllConsents();
                    // Google Maps
                    $('.uoConsentDummyMapOverlay').each(function(){
                        $(this).hide();
                    });
                    createAllIframe(overlayClassGoogleMaps);
                    // YouTube
                    $('.uoConsentDummyYtOverlay').each(function(){
                        $(this).hide();
                    });
                    createAllIframe(overlayClassYoutube);
                    // Vimeo
                    $('.uoConsentDummyVimeoOverlay').each(function(){
                        $(this).hide();
                    }); 
                    createAllIframe(overlayClassVimeo);
                    // 3Q Video
                    $('.uoConsentDummy3QOverlay').each(function(){
                        $(this).hide();
                    }); 
                    createAllIframe(overlayClass3Q);
                    // Facebook
                    $('.uoConsentDummyFacebookOverlay').each(function(){
                        $(this).hide();
                    }); 
                    createAllIframe(overlayClassFacebook);
                });
            });
                
            // show CenteredModal Options
            $('.uoConsentOptions').each(function(){
                $(this).on("click", function(e){
                    e.preventDefault();
                    usercentrics.toggleCenteredModalIsVisible();
                });
            });
            
            // eventListener On-Click:
            // Accept Google Maps Only
            acceptSingleConsent(buttonClassGoogleMaps, consentIdGoogleMaps, overlayGoogleMapsClass, overlayClassGoogleMaps);
            // Accept Youtube Only
            acceptSingleConsent(buttonClassYt, consentIdYoutube, overlayYoutubeClass, overlayClassYoutube);
            // Accept Vimeo Only
            acceptSingleConsent(buttonClassVimeo, consentIdVimeo, overlayVimeoClass, overlayClassVimeo);
            // Accept 3Q Only
            acceptSingleConsent(buttonClass3Q, consentId3Q, overlay3QClass, overlayClass3Q);
            // Accept Facebook Only
            acceptSingleConsent(buttonClassFacebook, consentIdFacebook, overlayFacebookClass, overlayClassFacebook);

            // Check if XYZ got accepted/ has consent
            window.addEventListener("ucEvents", function (e) {
                // GoogleMaps
                addEventListenerHideOverlay(consentIdGoogleMaps, overlayGoogleMapsClass, overlayClassGoogleMaps);
                // Youtube
                addEventListenerHideOverlay(consentIdYoutube, overlayYoutubeClass, overlayClassYoutube);
                // Vimeo
                addEventListenerHideOverlay(consentIdVimeo, overlayVimeoClass, overlayClassVimeo);
                // 3Q Video
                addEventListenerHideOverlay(consentId3Q, overlay3QClass, overlayClass3Q);
                // Facebook
                addEventListenerHideOverlay(consentIdFacebook, overlayFacebookClass, overlayClassFacebook);
            }); 
        }

        // Usercentrics CMP V2
        if(version === 'V2') {
            initConsent(consentArr);

            // consentChange is triggered too often, react on the last consentChange-Event
            timer = 0;
            $(window).on('consentChange', function(e){
                if (timer) {
                    clearTimeout(timer);
                }
                timer = setTimeout(function() {
                    checkConsent(consentArr);
                    /* console.log('consentChange', arguments); */
                }, 400); 
            });
        }
    });
    
});

function checkConsent(consentArr) {
    try{
        UC_UI.getServicesBaseInfo().forEach(function (consent) {
            if(typeof consentArr[consent.id] !== 'undefined') {
                if(consent.consent.status == true) {
                    // Function erstelle iFrame, falls keines vorhanden
                    var overlayClass = consentArr[consent.id].overlayClass;
                    createAllIframe(overlayClass);
                    $('.' + consentArr[consent.id].bannerClass).hide();
                }
            }
        });
    }
    catch(e){
        /* console.log(e); */
    }
}

function initConsent(consentArr) {
    try{
        UC_UI.getServicesBaseInfo().forEach(function (consent) {
            if(typeof consentArr[consent.id] !== 'undefined') {
                if(consent.consent.status == true) {
                    // Function erstelle iFrame, falls keines vorhanden
                    var overlayClass = consentArr[consent.id].overlayClass;
                    createAllIframe(overlayClass);
                }
                else {
                    // Erstelle Overlay
                    var overlayClass = consentArr[consent.id].overlayClass;
                    var overlay = consentArr[consent.id].overlay;
                    var buttonClass = consentArr[consent.id].buttonClass;
                    var bannerClass = consentArr[consent.id].bannerClass;
                    createOverlayFor(overlayClass, overlay);
                    addEventlistenerForV2(buttonClass, consent.id, bannerClass, overlayClass);
                }
            }
        });
        $('.uoConsentAcceptAll').each(function() {
            $(this).on("click", function(e){
                e.preventDefault();
                acceptAllConsents(consentArr);
            });
        });
        $('.uoConsentOptions').each(function(){
            $(this).on("click", function(e){
                e.preventDefault();
                UC_UI.showSecondLayer();
            });
        });
    }
    catch(e){
        /* console.log(e); */
    }
}

function acceptAllConsents(consentArr) {
    try{
        // accept all consents
        var consents = [];
        UC_UI.getServicesBaseInfo().forEach(function (consent) {
            consents.push(consent.id);
        });
        var time = 0;
        consents.forEach(function(consent) {
            setTimeout(function(){
                // Accept every Consent
                UC_UI.acceptService(consent);

                // Remove all Overlays
                if(typeof consentArr[consent] !== 'undefined') {
                    $('.' + consentArr[consent].bannerClass).hide()
                    createAllIframe(consentArr[consent].overlayClass);
                }
            },time);
            time += 80;
        });
    }
    catch(e) {/* console.log(e); */}
}
function createOverlayFor(overlayClass, overlay) {
    try{
        $('.' + overlayClass).each(function(){
            $(this).append(overlay);
        });
    }
    catch(e){
        /* console.log(e); */
    }
}

function addEventlistenerForV2(buttonClass, consentId, overlay, overlayClass) {
    try{
        $('.' + buttonClass).each(function(){
            var element = $(this);
            element.on("click", function(event){
                event.preventDefault();
                UC_UI.acceptService(consentId);
                $('.' + overlay).each(function(){
                    $(this).hide();
                });
                createAllIframe(overlayClass);
            }); 
        });
       
    }
    catch(e){/* console.log(e); */}
}

function createAllIframe(overlayClass) {
    try{
        // If it has a src, generate an iFrame.
        if($("." + overlayClass)) {
            $("." + overlayClass).each(function(){
                var element = $(this);
                createIframe(element, overlayClass);
            });
        } 
    }
    catch(e){/* console.log(e); */}
}

function createIframe(element, overlayClass) {
    try{
        // If it has a src, generate an iFrame.
        if(element) {
            element.each(function(){
                var this_element = $(this);
                if(this_element.data(overlayClass.toLowerCase())) {
                    if ($(this).closest('.' + overlayClass).find("iframe").data('uoconsent') != 1) {
                        var ifrm = document.createElement("iframe");
                        ifrm.setAttribute("src", element.data(overlayClass.toLowerCase()));
                        if(element.data('width')) {
                            ifrm.setAttribute('width', element.data('width'));
                        }
                        if(element.data('height')) {
                            ifrm.setAttribute('height', element.data('height'));
                        }
                        if(element.data('class')) {
                            ifrm.setAttribute('class', element.data('class'));
                        }
                        if(element.data('allowfullscreen')) {
                            ifrm.setAttribute('allowfullscreen', element.data('allowfullscreen'));
                        }
                        if(element.data('style')) {
                            ifrm.setAttribute('style', element.data('style'));
                        }
                        if(element.data('scrolling')) {
                            ifrm.setAttribute('scrolling', element.data('scrolling'));
                        }
                        if(element.data('frameborder')) {
                            ifrm.setAttribute('frameborder', element.data('frameborder'));
                        }
                        if(element.data('allowtransparency')) {
                            ifrm.setAttribute('allowtransparency', element.data('allowtransparency'));
                        }
                        if(element.data('allow')) {
                            ifrm.setAttribute('allow', element.data('allow'));
                        }
                        if(element.data('id')) {
                            ifrm.setAttribute('id', element.data('id'));
                        }
                        ifrm.setAttribute('data-uoconsent', '1');
                        
                        element.append(ifrm);
                    }
                }
            });
        } 
    }
    catch(e){/* console.log(e); */}
}

function checkConsentFor(consentId, overlayClass, overlay) {
    try{
        if(!(usercentrics.getConsents(consentId).consentStatus)) {
            $('.' + overlayClass).each(function(){
                $(this).append(overlay);
            });
        } 
        else {
            createAllIframe(overlayClass);
        }
    }
    catch(e){
        /* console.log(e); */
        $('.' + overlayClass).each(function(){
            $(this).append(overlay);
        });
    }
}

function acceptSingleConsent(buttonClass, consentId, overlay, overlayClass) {
    try{
        $('.' + buttonClass).each(function(){
            var element = $(this);
            element.on("click", function(event){
                event.preventDefault();
                usercentrics.updateConsents([{'templateId':consentId, 'status':true}]);
                $('.' + overlay).each(function(){
                    $(this).hide();
                });
                createAllIframe(overlayClass);
            }); 
        });
    }
    catch(e){/* console.log(e); */}
}

function addEventListenerHideOverlay(consentId, overlay, overlayClass) {
    try {
        if (usercentrics.getConsents(consentId).consentStatus) {
            $('.' + overlay).each(function () {
                $(this).hide();
                createAllIframe(overlayClass);
            });
        }
    } catch (e) {/* console.log(e); */}
}

function defer(callback) {
    window.jQueryCheck = setInterval(function() {
        if (typeof window.jQuery !== 'undefined') {
            clearInterval(window.jQueryCheck);
            if (typeof callback === 'function') {
                callback();
            }
        }
    }, 100);
}

function deferUsercentrics(callback) {
    window.usercentricsCheck = setInterval(function() {
        if (typeof window.usercentrics !== 'undefined') {
            clearInterval(window.usercentricsCheck);
            if (typeof callback === 'function') {
                version = 'V1';
                callback();
            }
        }
        else if(typeof window.UC_UI !== 'undefined') {
            clearInterval(window.usercentricsCheck);
            if (typeof callback === 'function') {
                version = 'V2';
                callback();
            }
        }
    }, 100);
}